var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[(_vm.title)?_c('div',{staticClass:"chart-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('bar-chart',{staticStyle:{"min-height":"382px"},attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }